import React, { useState, useEffect, ChangeEvent, useRef } from "react";
import "./component.css";
import {
  ADD_DOC_FILE,
  GET_ALL_ACCESSIBLE_DOCS,
  LINK_EMAIL_OR_PHONE,
  PATCH_USER_INFO,
  SEND_OTP,
  VALIDATE_OTP,
} from "../utils/constants";
import {
  makeAuthenticatedGet,
  makeAuthenticatedPostForFile,
  makePost,
} from "../utils/fetchUtils";
import { useNavigate } from "react-router-dom";
import { Bounce, ToastContainer, toast } from "react-toastify";
import { DocData } from "../utils/types";
import uploadImg from "../assets/upload-img.svg";
import or from "../assets/or.svg";
import downArrow from "../assets/down-arrow.svg";
import useWindowWidth from "../utils/windowWidth";
import EmailOtpModal from "./EmailOtpModal";
import PhoneOtpModal from "./PhoneOtpModal";

// Define the type for form data
type FormDataType = {
  email: string;
  confirmEmail: string;
  phoneNumber: string;
  confirmPhoneNumber: string;
};

const LinkEmailForm = (props: any) => {
  const { toLink } = props;
  const navigate = useNavigate();

  const inputRef = useRef<HTMLInputElement>(null);

  // react states
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [emailModalShow, setEmailModalShow] = useState(false);
  const [phoneModalShow, setPhoneModalShow] = useState(false);
  const [formData, setFormData] = useState<FormDataType>({
    email: "",
    confirmEmail: "",
    phoneNumber: "",
    confirmPhoneNumber: "",
  });
  const [isDirty, setIsDirty] = useState(false);
  const [error, setError] = useState<string>("");

  // const handleOptionChange = (event: any) => {
  //   setSelectedOption(event.target.value);
  //   handleChange(event);
  // };

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    // Update form data
    const updatedFormData = {
      ...formData,
      [name]: value,
    };

    setFormData(updatedFormData);

    setError("");
    setIsDirty(false);

    if (updatedFormData.email !== updatedFormData.confirmEmail) {
      setError("Emails do not match.");
      setIsDirty(true);
    } else {
      setError("");
      setIsDirty(false);
    }
    if (updatedFormData.phoneNumber !== updatedFormData.confirmPhoneNumber) {
      setError("Numbers do not match.");
      setIsDirty(true);
    } else {
      setError("");
      setIsDirty(false);
    }
  };

  const emailValidator = () => {
    setError("");
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(formData.email)) {
      setError("Please enter a valid email address");
      return false;
    }
    return true;
  };

  const phoneValidator = () => {
    setError("");
    if (formData.phoneNumber.length !== 10) {
      setError("Enter valid 10 Digit Number");
      return false;
    }
    if (!/^\d*$/.test(formData.phoneNumber)) {
      setError("Please enter a valid phone number");
      return false;
    }
    return true;
  };

  const handleSendOtp = async (choice: string) => {
    const body = {
      email: formData.email,
      phoneNumber: formData.phoneNumber,
    };
    if (choice === "phone") {
      body.email = "";
    } else {
      body.phoneNumber = "";
    }
    const resp = await makePost(SEND_OTP, JSON.stringify(body));
    if (resp.success === true) {
      setOtpSent(true);
    } else {
      setError(resp.message);
      // setError(resp.message);
    }
  };

  const handleOtpValidation = async (choice: any) => {
    setError("");
    try {
      const body = {
        otp: otp,
        phoneNumber: formData.phoneNumber,
        email: formData.email,
      };
      if (choice === "phone") {
        body.email = "";
      } else {
        body.phoneNumber = "";
      }
      console.log(body);
      const response = await makePost(VALIDATE_OTP, JSON.stringify(body));
      // console.log(response);
      if (response.success === true) {
        setError("");
        handleLinkAccount();
      } else {
        setError("OTP validation failed");
      }
      console.log(response);
    } catch (error: any) {
      setError("");
      if (error.response && error.response.data) {
        setError(error.response.data.message);
      }
    }
  };

  // Handle form submission
  const handleLinkAccount = () => {
    console.log(formData);

    // Validate inputs
    if (!((formData.email && formData.confirmEmail) || (formData.phoneNumber && formData.confirmPhoneNumber))) {
      setError("Both fields are required.");
      setIsDirty(true);
      return;
    }
    // Process form data
    const formDataToSubmit = new FormData();
    if (formData.email) {
      formDataToSubmit.append("email", formData.email);
    } else if (formData.phoneNumber) {
      formDataToSubmit.append("phoneNumber", formData.phoneNumber);
    }
    // Example: Sending data to an API
    console.log("Form Data:", formDataToSubmit);

    makeAuthenticatedPostForFile(LINK_EMAIL_OR_PHONE, formDataToSubmit)
      .then((response) => {
        console.log(response);
        navigate("/profile");
      })
      .catch((error) => console.log(error));
  };

  //use Effects

  useEffect(() => {}, [formData]);

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <>
      <form
        className="doc-form d-flex reset-password-form"
        // onSubmit={handleSubmit}
        aria-live="polite"
        id="myForm"
      >
        <p style={{ marginRight: "auto" }}>
          {`Please enter your ${toLink} to link`}
        </p>
        <div className="input-div-container">
          {toLink === "email" && (
            <div
              className="input-container"
              style={{ width: isMobile ? "90%" : "55%" }}
            >
              <div className="mb-3 input-div input-div-10">
                <h2 id="email-label" className="form-label">
                  Email
                </h2>
                <input
                  style={{
                    marginTop: "1rem",
                    lineHeight: "3.5rem",
                    borderColor: error ? "red" : "initial",
                  }}
                  className="form-control input-5"
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  aria-labelledby="email-label"
                  placeholder="enter email"
                  onChange={handleChange}
                ></input>
              </div>
              <EmailOtpModal
                otp={otp}
                setOtp={setOtp}
                handleOtpValidation={handleOtpValidation}
                email={formData.email}
                show={emailModalShow}
                setShow={setEmailModalShow}
                onHide={() => {
                  setEmailModalShow(false);
                  setOtp("");
                  setOtpSent(false);
                }}
              />
            </div>
          )}
          {toLink === "phone" && (
            <div
              className="input-container"
              style={{ width: isMobile ? "90%" : "55%" }}
            >
              <div className="mb-3 input-div input-div-10">
                <h2 id="phone-number-label" className="form-label">
                  Phone Number
                </h2>
                <input
                  style={{
                    marginTop: "1rem",
                    lineHeight: "3.5rem",
                    borderColor: error ? "red" : "initial",
                  }}
                  className="form-control input-5"
                  id="phone-number"
                  name="phoneNumber"
                  type="text"
                  value={formData.phoneNumber}
                  aria-labelledby="phone-number-label"
                  placeholder="enter Phone number"
                  onChange={handleChange}
                ></input>
              </div>
              <PhoneOtpModal
            show={phoneModalShow}
            setShow={setPhoneModalShow}
            onHide={() => {
              setPhoneModalShow(false);
              setOtp("");
              setOtpSent(false);
            }}
            otpSent={otpSent}
            otp={otp}
            setOtp={setOtp}
            handleOtpValidation={handleOtpValidation}
            phoneNumber={formData.phoneNumber}
          />
            </div>
          )}
          {toLink === "email" && (
            <div
              className="input-container"
              style={{ width: isMobile ? "90%" : "55%" }}
            >
              <div className="mb-3 input-div input-div-10">
                <h2 id="confirm-email-label" className="form-label">
                  Confirm Email
                </h2>
                <input
                  style={{
                    marginTop: "1rem",
                    lineHeight: "3.5rem",
                    borderColor: error ? "red" : "initial",
                  }}
                  className="form-control input-5"
                  id="confirm-email"
                  name="confirmEmail"
                  type="email"
                  value={formData.confirmEmail}
                  aria-labelledby="confirm-email-label"
                  placeholder="confirm new email"
                  onChange={handleChange}
                ></input>
              </div>
            </div>
          )}
          {toLink === "phone" && (
            <div
              className="input-container"
              style={{ width: isMobile ? "90%" : "55%" }}
            >
              <div className="mb-3 input-div input-div-10">
                <h2 id="confirm-phone-number-label" className="form-label">
                  Confirm Phone Number
                </h2>
                <input
                  style={{
                    marginTop: "1rem",
                    lineHeight: "3.5rem",
                    borderColor: error ? "red" : "initial",
                  }}
                  className="form-control input-5"
                  id="confirm-phone-number"
                  name="confirmPhoneNumber"
                  type="text"
                  value={formData.confirmPhoneNumber}
                  aria-labelledby="confirm-phone-number-label"
                  placeholder="confirm phone number"
                  onChange={handleChange}
                ></input>
              </div>
            </div>
          )}
          {error && (
            <p
              className="text-danger mt-2"
              role="alert"
              style={{
                color: "red",
                fontSize: "1rem",
                fontWeight: "bold",
              }}
            >
              {error}
            </p>
          )}
          <div
            style={{ width: "100%", paddingTop: "2rem" }}
            className="d-flex items-center"
          >
            <button
              className="doc-submit"
              disabled={isDirty}
              form="myForm"
              style={{
                borderRadius: "0.5rem",
                opacity: isDirty ? "0.7" : "1",
                cursor: isDirty ? "not-allowed" : "pointer",
              }}
              onClick={(e:any) => {
                e.preventDefault();
                if (toLink === "email" && emailValidator()) {
                  setEmailModalShow(true);
                  handleSendOtp("email");
                }
                if(toLink === "phone" && phoneValidator()) {
                  setPhoneModalShow(true);
                  handleSendOtp("phone");
                }
              }}
            >
              Update {toLink === "email" ? "Email" : "Phone"}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default LinkEmailForm;
